import React from "react";

function ListCategories({ categories, filterItem }) {
  return (
    <div>
      <div className="btn-container">
        {categories.map((catagory, index) => {
          return (
            <button
              type="button"
              key={index}
              onClick={() => {
                filterItem(catagory);
              }}
              className="badge badge-pill badge-secondary  allCategories"
            >
              {catagory}
            </button>
          );
        })}
      </div>
      <br></br>
    </div>
  );
}

export default ListCategories;
